import './scripts/modernizr';
import header from './scripts/header';
import trialsAPI from './scripts/trialsAPI';
import replaceIcons from './scripts/icons';
import wordpressUI from './scripts/wordpressUI';
import wordpressBlocks from './scripts/wordpressBlocks';
import clinicalTrialsContactForm from './scripts/clinicalTrialsContactForm';

import accordion from './template-parts/blocks/accordion';
import modal from './template-parts/blocks/modal';
import trialFilters from './template-parts/blocks/trials';
import trialScreener from './template-parts/blocks/trial-screener';
declare global {
  interface Window {
    gmak: string; // gmak - Google Maps API Key
    initGoogleMaps: () => void;
    Sentry?: {
      captureException: (e: Error) => void;
    };
  }
}

export const docReady: (fn: () => void) => void = (fn) => {
  // see if DOM is already available
  if (
    document.readyState === 'complete' ||
    document.readyState === 'interactive'
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

if (window.location.href.includes('post.php')) {
  setTimeout(() => {
    wordpressUI();
  }, 100);
} else {
  docReady(() => {
    [
      header,
      trialsAPI,
      replaceIcons,
      accordion,
      clinicalTrialsContactForm,
      modal,
      trialFilters,
      trialScreener,
      wordpressBlocks,
    ].forEach((fn) => {
      try {
        fn();
      } catch (e) {
        console.error(e);
        try {
          if (
            typeof window.Sentry === 'object' &&
            typeof window.Sentry.captureException === 'function'
          ) {
            window.Sentry.captureException(e);
          }
        } catch (_e) {
          console.error('Failed to send error to Sentry');
          console.error(_e);
        }
      }
    });
  });
}
